import script from "./Photography.vue?vue&type=script&setup=true&lang=js"
export * from "./Photography.vue?vue&type=script&setup=true&lang=js"

import "./Photography.vue?vue&type=style&index=0&id=acc82326&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acc82326"]])

export default __exports__